const CryptoJS = require('crypto-js') //引用AES源码js

const key = CryptoJS.enc.Utf8.parse('cbim3userInfohhh') //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('cbim3userInfo666') //十六位十六进制数作为密钥偏移量

//解密方法
function Decrypt(word: string) {
    const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
    const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    const decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
}

//加密方法
function Encrypt(word: string) {
    const srcs = CryptoJS.enc.Utf8.parse(word)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.ciphertext.toString().toUpperCase()
}

export { Decrypt, Encrypt }
